import {
  API_END_POINT,
  axiosInstance,
  ENTITY_MANAGER_END_POINTS,
  resolveEntityName,
  validateApiParams,
} from '@app-store'

export const fetchMacrosApi = async (
  entityName: string,
  recordId: number,
  macros: string[]
) => {
  const resolvedEntityName = resolveEntityName(entityName, undefined)
  const endpoint = `${API_END_POINT.ENTITY_MANAGER_V3}${ENTITY_MANAGER_END_POINTS.ENTITY_DATA}/${resolvedEntityName}`
  validateApiParams(
    { entityName: resolvedEntityName },
    { endpoint, method: 'POST' }
  )
  return await axiosInstance.post(endpoint, {
    recordId: recordId,
    macros: macros,
  })
}
